import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _7kIcon(props: IconProps) {
    return <Icon {...props} iconKey={"7k"}/>
}
